import { jsx, jsxs } from 'react/jsx-runtime';
import { useRef, useState, useCallback } from 'react';
import { Typography } from '../../components/Typography/Typography.js';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '../../config/LSSuffix.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import '../../context/ViewContext/ViewContext.js';
import { ReactComponent as SvgClose } from '../../shared/assets/close.js';
import { ReactComponent as SvgSignCircle } from '../../shared/assets/sign-circle.js';
import '@dynamic-labs/utils';
import '../../utils/constants/colors.js';
import 'ethers';
import { usePreventPageScroll } from '../../shared/utils/hooks/usePreventPageScroll/usePreventPageScroll.js';
import { authModalZIndex } from '../../shared/consts/index.js';
import '../../context/DynamicContext/DynamicContext.js';
import '@dynamic-labs/multi-wallet';
import '../../components/ShadowDOM/ShadowDOM.js';
import '../../context/ThemeContext/ThemeContext.js';
import { Icon } from '../../components/Icon/Icon.js';
import { Portal } from '../../components/Portal/Portal.js';
import 'react-dom';
import '../../config/ApiEndpoint.js';
import '@dynamic-labs/rpc-providers';
import '../../context/ErrorContext/ErrorContext.js';
import '../../context/AccessDeniedContext/AccessDeniedContext.js';
import { ModalHeader } from '../../components/ModalHeader/ModalHeader.js';
import { IconButton } from '../../components/IconButton/IconButton.js';
import '@dynamic-labs/wallet-book';
import { PoweredByDynamic } from '../../components/PoweredByDynamic/PoweredByDynamic.js';
import { Button } from '../../components/Button/Button.js';
import { IconWithSpinner } from '../../components/IconWithSpinner/IconWithSpinner.js';
import { AnimatePresence } from '../../components/AnimatePresence/AnimatePresence.js';
import '../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../components/Transition/OpacityTransition/OpacityTransition.js';
import { VerticalDrawerTransition } from '../../components/Transition/VerticalDrawerTransition/VerticalDrawerTransition.js';
import '../../components/Alert/Alert.js';
import { AppOriginTile } from '../../components/AppOriginTile/AppOriginTile.js';
import '../../context/MockContext/MockContext.js';
import '../../context/CaptchaContext/CaptchaContext.js';
import { useMutation } from '../../utils/hooks/useMutation/useMutation.js';
import '../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import { ErrorContainer } from '../../components/ErrorContainer/ErrorContainer.js';
import '../../components/Popper/Popper/Popper.js';
import '../../components/Popper/PopperContext/PopperContext.js';
import 'formik';
import 'yup';
import { Modal } from '../../components/Modal/Modal.js';
import { ModalCard } from '../../components/ModalCard/ModalCard.js';
import '../../components/MenuList/Dropdown/Dropdown.js';

const SignMessageConfirmationModal = ({ appLogoUrl, appName, appOrigin, message, handler, onReject, onSignMessage, }) => {
    usePreventPageScroll(true);
    const didConfirmRef = useRef(false);
    const [show, setShow] = useState(true);
    const handleOnReject = useCallback(() => {
        didConfirmRef.current = false;
        setShow(false);
    }, [setShow]);
    const { isLoading, mutate: confirm, data: signedMessage, error: signMessageError, } = useMutation(() => handler(message), {
        onSuccess: () => {
            didConfirmRef.current = true;
            setShow(false);
        },
    });
    const handleOnModalUnmount = useCallback(() => {
        if (signedMessage) {
            return onSignMessage(signedMessage);
        }
        onReject(signMessageError || new Error('user rejected signing'));
    }, [signedMessage, onSignMessage, onReject, signMessageError]);
    const closeButton = (jsx(IconButton, Object.assign({ type: 'button', onClick: handleOnReject, "data-testid": 'close', disabled: isLoading }, { children: jsx(SvgClose, {}) })));
    return (jsx(Portal, Object.assign({ handleClose: handleOnReject, isShown: show, zIndex: authModalZIndex, withBackdrop: true, elementId: 'dynamic-sign-message', transitionEvents: {
            onUnmount: handleOnModalUnmount,
        } }, { children: jsx(Modal, { children: jsxs(ModalCard, { children: [jsx(ModalHeader, Object.assign({ trailing: closeButton, alignContent: 'bottom' }, { children: jsx(IconWithSpinner, { Icon: (props) => (jsx(Icon, Object.assign({ color: 'brand-primary' }, { children: jsx(SvgSignCircle, Object.assign({}, props)) }))), iconSize: 64, isSpinning: true }) })), jsxs("div", Object.assign({ className: 'sign-message-confirmation__body' }, { children: [jsx(Typography, Object.assign({ variant: 'title', color: 'primary', className: 'sign-message-confirmation__title' }, { children: "Requesting Signature" })), jsx(AnimatePresence, Object.assign({ animationComponent: jsx(VerticalDrawerTransition, {}) }, { children: signMessageError && (jsx("div", Object.assign({ className: 'sign-message-confirmation__error' }, { children: jsx(ErrorContainer, { children: signMessageError.reason || 'Something went wrong' }) }))) })), jsxs("div", Object.assign({ className: 'sign-message-confirmation__message-container' }, { children: [jsx(AppOriginTile, { appLogoUrl: appLogoUrl, appName: appName, appOrigin: appOrigin }), jsx("div", Object.assign({ className: 'sign-message-confirmation__message' }, { children: jsx(Typography, Object.assign({ color: 'primary', variant: 'body_normal' }, { children: message })) }))] })), jsxs("div", Object.assign({ className: 'sign-message-confirmation__actions' }, { children: [jsx(Button, Object.assign({ buttonVariant: 'secondary', onClick: handleOnReject, expanded: true, buttonPadding: 'large', disabled: isLoading, buttonRounded: 'default' }, { children: "Cancel" })), jsx(Button, Object.assign({ buttonVariant: 'primary', buttonPadding: 'large', onClick: () => confirm(), expanded: true, buttonRounded: 'default', loading: isLoading }, { children: "Sign" }))] })), jsx(PoweredByDynamic, {})] }))] }) }) })));
};

export { SignMessageConfirmationModal };
